'use client';

import Slider from 'react-slick';
import { FC, Key, useState, useEffect, useRef } from 'react';

import { Box } from '@mui/material';

import Image from '../../../../components/image';
import { API } from '../../../../helpers/api';
import { ComponentTypeProps } from '../../../../types/page-generator';
import { useResponsive } from '../../../../hooks/use-responsive';
import { useAuthContext } from '../../../../auth/hooks';

export const AddsCarouselSmall: FC<ComponentTypeProps> = ({ block }) => {
  const { user } = useAuthContext();
  const sliderRef = useRef<Slider | null>(null);
  const isMobile = useResponsive('down', 'sm');
  const [allPrograms, setAllPrograms] = useState<any>([]);
  const settings = {
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: isMobile ? 3 : 7,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: block && block.settings ? (block.settings.playSpeed || 3) * 1000 : 3 * 1000,
  };
  const { combinedCarouselBanner1 }: any = block;
  const position = (item: any) => {
    if (item.position === 'start') return 'fex-start';
    if (item.position === 'center') return 'center';
    if (item.position === 'end') return 'fex-end';
    return 'center';
  };

  const getAllPrograms = async () => {
    const { data } = await API({
      url: '/ad-program',
      method: 'GET',
      params: { offset: 0 },
    });
    setAllPrograms(data.payload);
  };

  useEffect(() => {
    if (user) {
      getAllPrograms();
    }
  }, []);

  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(0); // Обновляем карусель
    }
  }, [allPrograms]);

  const programs = allPrograms.filter((program: any) => program.size === '48x100');
  return (
    <Box
      sx={{
        '& .slick-slide': {
          mb: '20px',
          mr: '10px',
          width: '108px!important',
          height: '40px',
        },
        '& .slick-slider': {
          '& .slick-dots': {
            position: 'absolute',
            bottom: block?.settings?.isAlternativeDesign ? '100px' : '0px',
            '& .slick-active': {
              '& button': {
                '&::before': {
                  color: block?.settings?.dotsColor,
                },
              },
            },
            '& li': {
              '& button': {
                width: '20%',
                '&::before': {
                  color: block?.settings?.dotsColor,
                },
              },
            },
          },
        },
      }}
    >
      <Slider ref={sliderRef} {...settings}>
        {programs?.map((item: any, index: Key) => (
          <Image
            key={index}
            src={`https://drive.b24online.com/public-assets/${item.image.folder}/${item.image.filename}`}
            sx={{ width: '108px', height: '48px', borderRadius: '10px' }}
          />
        ))}
      </Slider>
    </Box>
  );
};
